import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useTranslation} from "react-i18next";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import React from 'react';
import {monthNames} from '../Trans.js'
import StatsRow from './StatsRow.js';

const StatsYearTable = ((props) => {
	const {t} = useTranslation('obs');

	function yearSrc() {
		let prev_month = -1, i;
		let ret = [];

		let ol = props.src.length;

		for (i = ol - 1; i >= 0; i--) {
			let obs = props.src[i];
			const month = new Date(obs.start_t * 1000.0).getMonth();
			let bg;

			if (month !== prev_month) {
				let j, n;

				n = 1;

				for (j = i - 1; j >= 0; j--) {
					let obs2 = props.src[j];
					const month2 = new Date(obs2.start_t * 1000.0).getMonth();

					if (month2 !== month) 
						break;

					n++;
				}

				if (prev_month !== - 1)
					ret.push(
						<TableRow key={-month * 2 - 1}>
							<TableCell colSpan={4}>
								&nbsp;
							</TableCell>
						</TableRow>);

				ret.push(<TableRow key={-month * 2} style={{backgroundColor: '#f0f0f0'}}><TableCell colSpan={4}> {t(monthNames[month]) + ' ' + n + ' ' + t('stats.species')} </TableCell></TableRow>);
			}

			bg =  props.src[i].lifer ? '#cbffe2' : '#ffffff';

			ret.push(
				<StatsRow
					key	= {i + 1}
					bgcolor	= {bg}
					row_n	= {i + 1}
					obs	= {obs}
				/>);

			prev_month = month;
		}

		return ret;
	}

	if (!props.src || !Array.isArray(props.src))
		return null;

	return (
		<TableContainer component={Paper} elevation={0}>
			<Table size='small'>
				<TableHead>
					<TableRow>
						<TableCell>#</TableCell>
						<TableCell>{t('main.species')}</TableCell>
						<TableCell>{t('main.time')}</TableCell>
						<TableCell>{t('main.location')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{yearSrc()}
				</TableBody>
			</Table>
		</TableContainer>
	);
});

export default StatsYearTable;
